import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { APICONSTANTS } from "../../constants/api-constants";
import { PeriodeSageModel } from "../../models/societe-linked/periode-sage.model";
import { HostnameService } from "../basic/hostname.service";
import { SocieteLinkedService } from "./societe-linked.service";

@Injectable()
export class PeriodeSageService extends SocieteLinkedService<PeriodeSageModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTEPERIODESAGE, hostnameService);
    }

    getAnnee(annee: number, idSociete: number) {
        return this.http.get<PeriodeSageModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAnnee?annee=' + annee + '&idSociete=' + idSociete)
      .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
    }
    getAllAnnee(idSociete: number) {
      return this.http.get<number[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllAnnee?idSociete=' + idSociete)
    .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
    }
    getAllbySociete(idSociete: number) {
      return this.http.get<PeriodeSageModel[]>(APICONSTANTS.URLAPI.value + this.route + 'getAllbySociete?idSociete=' + idSociete)
    .pipe(catchError(err => this.requestCatchError(err, 'Le chargement')));
    }

    postAll(objets: PeriodeSageModel[]): Observable<PeriodeSageModel[]> {
        return this.http.post<PeriodeSageModel[]>(APICONSTANTS.URLAPI.value + this.route + 'addAll/', objets)
      .pipe(catchError(err => this.requestCatchError(err, 'L\'ajout')));
    }

    updateAll(objets: PeriodeSageModel[]): Observable<PeriodeSageModel[]> {
        return this.http.post<PeriodeSageModel[]>(APICONSTANTS.URLAPI.value + this.route + 'updateAll/', objets)
      .pipe(catchError(err => this.requestCatchError(err, 'L\'ajout')));
    }
}